import localScaleManager from "../../../../helpers/LocalScaleManager";
import { Parser } from "../../../../helpers/parser";
import { tweenConfigs } from "../../../../helpers/tweensConfigs";
import { gameConfig } from "../../../../helpers/gameConfig";

export class WinAmount {
  /**
   * @param scene {GameScene}
   * @param table {Table}
   * @param seat {Seat}
   */
  constructor(scene, table, seat) {
    this.scene = scene;
    this.table = table;
    this.seat = seat;
    this.winAmount = 10000;
    this.text = this.scene.add
      .bitmapText(0, 0, "HelveticaNeueTeal", this.winAmount)
      .setDepth(20);
    this.table.poolArray.push(this.text);

    this.text.setData("width", this.text.width);
    this.text.setData("height", this.text.height);
    this.text.setVisible(false);

    this.tweenY = 0;
    this.seatBoxInitX = 0;
    this.seatBoxInitY = 0;
    this.seatBoxWidth = 0;
    this.textInitY = 0;

    this.winBox = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "win-box")
      .setOrigin(0.5)
      .setDepth(11)
      .setVisible(false);
    this.table.poolArray.push(this.winBox);

    this.winTxt = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "win-text")
      .setOrigin(0.5)
      .setDepth(13)
      .setVisible(false);
    this.table.poolArray.push(this.winTxt);

    this.winGlow = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "win-triangle")
      .setOrigin(0.5)
      .setVisible(false);
    this.table.poolArray.push(this.winGlow);

    this.winStar = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "win-star")
      .setOrigin(0.5)
      .setVisible(false);
    this.table.poolArray.push(this.winStar);
  }
  update(amount) {
    this.winAmount = amount;
  }
  show() {
    if (this.winAmount > 0 && this.seat.playerInfo.win > 0) {
      this.text.y = this.textInitY;
      this.text.setText(
        Parser.convertToXLetters("+" + this.winAmount.toLocaleString(), 15)
      );
      this.text.setPosition(
        this.seatBoxInitX - this.text.width / 2,
        this.seatBoxInitY + this.tweenY
      );
      this.text.setAlpha(1)
      if (this.scene.tweenEnable) {
        this.scene.tweens.add({
          targets: this.text,
          y: this.seatBoxInitY,
          duration: tweenConfigs.winText.duration,
          ease: tweenConfigs.winText.ease,
          delay: tweenConfigs.winChips.duration,
          alpha: 0,
          onStart: () => {
            if (!this.text.visible) this.text.setVisible(true);
            this.seat.box.updateBalance(true, this.seat.playerInfo.win, this.seat.playerInfo.balance);
            this.table.sounds.play("show-win-amount");
          },
          onComplete: () => {
            this.text.y = this.seatBoxInitY;
            this.text.alpha = 0;
            // this.scene.time.addEvent({
            //   delay: 3000, // ms
            //   callback: this.timeEvent,
            //   callbackScope: this,
            // });
          },
        });
      } else {
        this.seat.box.updateBalance();
      }
    }
  }
  playWinTween() {
    if (this.scene.tweenEnable) {
      this.winBox.setAlpha(0);
      this.winGlow.setAlpha(0);
      this.winBox.setVisible(true);
      this.winGlow.setVisible(true);
      this.seat.box.setAlpha(0.2);
      this.show();
      this.scene.tweens.add({
        targets: [this.winBox, this.winGlow],
        duration: tweenConfigs.winText.duration,
        ease: "Linear",
        alpha: 1,
        yoyo: true,
        hold: gameConfig.endStateDuration - 2.5 * tweenConfigs.winText.duration,
        onComplete: () => {
          this.winBox.setVisible(false);
          this.winGlow.setVisible(false);
          this.seat.box.resetAlpha();
        },
      });
      this.winStar.setAngle(0);
      this.winStar.setScale(0);
      this.winStar.setVisible(true);
      this.scene.tweens.add({
        targets: this.winStar,
        duration: tweenConfigs.winText.duration,
        ease: "Linear",
        angle: 45,
        scale: this.winStar.getData("initScale"),
        yoyo: true,
        hold: gameConfig.endStateDuration - 2.5 * tweenConfigs.winText.duration,
        onComplete: () => {
          this.winStar.setVisible(false);
        },
      });
      this.winTxt.setScale(this.winTxt.getData("initScale") * 4);
      this.winTxt.setAlpha(0);
      this.winTxt.setVisible(true);
      this.scene.tweens.add({
        targets: this.winTxt,
        duration: tweenConfigs.winText.duration,
        ease: "Linear",
        scale: this.winTxt.getData("initScale"),
        alpha: 1,
        yoyo: true,
        hold: gameConfig.endStateDuration - 2.5 * tweenConfigs.winText.duration,
        onComplete: () => {
          this.winTxt.setVisible(false);
        },
      });
    }
  }
  timeEvent() {
    if (this.text.visible) this.text.setVisible(false);
  }
  // handleVisibilityChange(hidden) {
  //   let activeTweens;
  //   if (hidden) {
  //     /* agar game hidden shod va active tween dashtim bayad hame ra foran b payan bbarim
  //      * ba tavajoh b inke agr tweeni k montazer etmam delay ast ra seek konim onStart on tween ejra nemishavad
  //      */
  //     activeTweens = this.scene.tweens.getTweensOf(this.text);
  //     activeTweens.forEach((tween) => {
  //       this.text.setVisible(true);
  //       tween.seek(1);
  //     });
  //   }
  // }
  /***
   *
   * @param width {number} width of seat box
   * @param height {number} width of seat box
   * @param initX {number} seat box top left x
   * @param initY {number} seat box top left y
   */
  positionControls(width, height, initX, initY) {
    // this.textSize = width / 1.2;
    this.textSize = width;
    this.seatBoxInitX = initX;
    this.seatBoxInitY = initY;
    this.seatBoxWidth = width;
    localScaleManager.scaleBitMapText(
      this.text,
      this.textSize,
      this.textSize,
      0,
      1,
      false
    );
    this.text.setPosition(initX - this.text.width / 2, initY);
    this.tweenY = height;
    this.textInitY = this.text.y;
    this.textInitScale = this.text.scale;

    localScaleManager.scaleSprite(
      this.winBox,
      width * 1.6,
      width * 1.6,
      0,
      1,
      true
    );
    // this.winBoxX = initX;
    // this.winBoxY = initY + height * .35;
    this.winBox.setPosition(initX, initY + height * 0.35);
    localScaleManager.scaleSprite(
      this.winTxt,
      width * 0.35,
      width * 0.35,
      0,
      1,
      true
    );
    // this.winTxtX = initX;
    // this.winTxtY = initY + height * .7;
    this.winTxt.setPosition(initX, initY + height * 0.7);
    this.winTxt.setData("initScale", this.winTxt.scale);
    const winScale = this.isMyTable ? width * 1.2 : width * 1.5;
    localScaleManager.scaleSprite(
      this.winStar,
      width * 1.5,
      width * 1.5,
      0,
      1,
      true
    );
    // this.winStarX = initX;
    // this.winStarY = initY - height * .35;
    this.winStar.setPosition(initX, initY - height * 0.35);
    this.winStar.setData("initScale", this.winStar.scale);
    localScaleManager.scaleSprite(
      this.winGlow,
      width * 2.5,
      width * 2.5,
      0,
      1,
      true
    );
    // this.winGlowX = initX;
    // this.winGlowY = initY - height * .7;
    this.winGlow.setPosition(initX, initY - height * 0.7);
    // setTimeout(()=> {
    //   if(!this.showTest){
    //     this.showTest = true;
    //     this.playWinTween()
    //   }
    // }, 5000);
  }
  reposition(width, height, initX, initY) {
    this.seatBoxInitX = initX;
    this.seatBoxInitY = initY;
    this.seatBoxWidth = width;
    this.text.setPosition(initX - this.text.width / 2, initY);
    this.tweenY = height;
    this.textInitY = this.text.y;
    this.winBox.setPosition(initX, initY + height * 0.35);
    this.winTxt.setPosition(initX, initY + height * 0.7);
    this.winStar.setPosition(initX, initY - height * 0.35);
    this.winGlow.setPosition(initX, initY - height * 0.7);
  }
  remove() {
    this.text.destroy();
  }
}
